// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileRoute_bottom__a0NsL{display:flex;height:80px;justify-content:center;margin-bottom:50px;padding:var(--s4);position:relative;width:100%;z-index:0}`, "",{"version":3,"sources":["webpack://./../../libraries/files/src/FileRoute/FileRoute.module.scss"],"names":[],"mappings":"AACA,yBAIE,YAAA,CAFA,WAAA,CAGA,sBAAA,CACA,kBAAA,CAHA,iBAAA,CAIA,iBAAA,CANA,UAAA,CAOA,SAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottom": `FileRoute_bottom__a0NsL`
};
export default ___CSS_LOADER_EXPORT___;
